export default __webpack_public_path__ + "static/media/access.f81d4a6f.svg";